<style lang="scss">
    .ls-upload {
        .el-button {
            margin-right: 15px;
        }
        ul {
            display: none;
        }
    }
</style>
<template>
    <div class="ls-upload">
        <el-button class="btn-blue" @click="submit" v-show="!read" :loading="loading">{{loading? '加载中...' : '选择文件'}}</el-button>

        <input type="file" ref="upload" style="display: none" @change="openFile($event)">
        <el-link type="primary" :underline="false" v-show="!model && loading">进度：{{percent}}%</el-link>
        <el-link type="primary" :underline="false" target="_blank" :href="prefixUrl + model" v-show="model">查看文件</el-link>
        <el-link type="danger" v-show="model" :underline="false" @click="model=''"><i class="el-icon-close"></i></el-link>
    </div>
</template>

<script>
    import service from '@/util/api'
    import axios from '@/util/api'
    import variable from '@/util/variable'
    import * as qiniu from 'qiniu-js'
    export default {
        name: 'LsUpload',
        props: {

            value: {},
            keyIndex: {},
            read: {
                type: Boolean,
                default: false,
            },
            title: {
                default: '上传文件'
            },
        },
        data() {
            return {
                loading: false,
                action: variable.qiniuUrl,
                prefixUrl: variable.cdn,
                fileList: [],
                postData: {
                    token: '',
                },
                percent: 0,

                model: '',
            }
        },
        created() {
            axios.get('sys/qiniu/token')
                .then(res => {
                    console.log(res);
                    this.postData.token = res.qiniuToken
                    this.prefixUrl = variable.cdn;
                })
        },
        watch: {
            value: {
                handler(val) {
                    this.model = val
                },
                immediate: true
            },
            model() {
                this.$emit('input', this.model)
            }
        },
        methods: {
            openFile($event) {
                this.loading = true;
                this.model = '';

                this.pre = this.prefixUrl;
                this.$help.success('正在上传')
                service.get('sys/qiniu/token')
                    .then(res => {
                        // 上传到七牛云上
                        const self = this;

                        if ($event.target.files.length === 1) {
                            let file = $event.target.files[0]
                            const req = qiniu.upload(file, `${new Date().getTime().toString()}${file.name.substr(file.name.lastIndexOf('.'))}`, res.qiniuToken)
                            req.subscribe({
                                next(param) {
                                    self.percent = param.total.percent.toFixed(0)
                                },
                                error() {
                                    self.loading = false;
                                },
                                complete(param) {
                                    self.loading = false;
                                    self.model = param.key;
                                    self.$help.success('上传成功')
                                },
                            })
                        }
                    })
                    .catch(error => {
                        this.$help.error(error.obj)
                    })
                    .finally(() => {
                        this.$refs.upload.value = null;
                    })
            },

            submit() {
                this.$refs.upload.click()
            },
        }
    }
</script>
